<template>
  <div class="d-flex flex-column flex-lg-row align-center header">
    <h1 class="header-title">
      {{ title }}
      <slot name="title"></slot>
    </h1>

    <div>
      <slot name="latestUpdate"></slot>
    </div>

    <div class="w-100">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style>
.header-title {
  font-size: 2rem;
  font-weight: 500;
  width: 100%;
}
</style>
